import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import GButton from "components/ui/button/Button";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  assigenTagsToProduct,
  getTagsInProduct,
  getTagsOfProduct,
} from "../../services/addingTagsService";

const AddingTagsModal = ({ onClose }) => {
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { handleSubmit, setValue } = useForm();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });

  const toast2 = useToast({
    position: "top",
    duration: 3000,
    status: "error",
  });

  const tags = useSelector((state) => state.addTags);

  useEffect(() => {
    dispatch(getTagsInProduct());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.inventory.add_tag")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.TagId = values.TagId?.TagId;
              values.ProductId = id.productId;
              values.UserId = localStorage.getItem("userId");
              if (values.TagId === undefined) {
                toast2({
                  description: t("pages.DailyRestrictions.searchvalidation"),
                });
              } else {
                dispatch(assigenTagsToProduct(values))
                  .unwrap()
                  .then((_) => {
                    toast({ description: "Tag Created" });
                    dispatch(getTagsOfProduct(id.productId));
                    onClose();
                  });
              }
            })}
          >
            <Stack>
              <MultiSelect
                title={t("pages.inventory.tags")}
                data={
                  tags.tagsInProduct &&
                  tags.tagsInProduct.map((el) => ({
                    ...el,
                    label: el.TagName,
                    value: el.TagId,
                  }))
                }
                isMulti={false}
                isRequired={true}
                onChange={(e) => setValue("TagId", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("pages.inventory_item_details.apply")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={tags.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={tags.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default AddingTagsModal;
